// extracted by mini-css-extract-plugin
export var csatScore = "_nr-5";
export var header = "_nr-1";
export var panelWrapper = "_nr-2";
export var postPreview = "_nr-3";
export var rightContent = "_nr-0";
export var wrappingText = "_nr-4";